import React, { useEffect, useState } from 'react'
import { Check, CheckGroup, CheckResult } from './api'
import { useDokumententresorChecks } from './dokumententresor'
import classes from './index.module.css'

const useCheckGroups = (): CheckGroup[] => {
    const dokumententresorChecks = useDokumententresorChecks()
    return [dokumententresorChecks]
}

export default function Checks() {
    const checkGroups = useCheckGroups()

    return (
        <div className="m-3">
            {checkGroups.map((checkGroup) => (
                <ul className="list-group" key={checkGroup.name}>
                    {checkGroup.checks.map((check) => (
                        <CheckComponent key={check.id} check={check} />
                    ))}
                </ul>
            ))}
        </div>
    )
}

function CheckComponent({ check }: { check: Check }) {
    const [checkResult, setCheckResult] = useState<CheckResult>({ status: 'running' })

    useEffect(() => {
        setCheckResult({ status: 'running' })
        check.func().then((result) => setCheckResult(result))
    }, [check])

    return (
        <li className="list-group-item">
            <h3>
                {checkResult?.status === 'running' && <span className={`${classes.badge} badge bg-info mr-2`}>LÄUFT</span>}
                {checkResult?.status === 'error' && <span className={`${classes.badge} badge bg-danger mr-2`}>FEHLER</span>}
                {checkResult?.status === 'success' && <span className={`${classes.badge} badge bg-success mr-2`}>OK</span>}
                {check.name}
            </h3>
            <small>
                {check.description && <div>{check.description}</div>}
                {check.link && (
                    <div>
                        <a href={check.link} target="_blank" rel="noreferrer">
                            {check.link}
                        </a>
                    </div>
                )}
            </small>
            {checkResult && <div className="mt-2 text-danger">{checkResult.msg}</div>}
        </li>
    )
}
